import React, { Fragment } from 'react';

const UserTeams = () => {
    return <Fragment>
        UserTeams
    </Fragment>
}
export default UserTeams;